import { AmicusBriefsApp } from '@/web-components/AmicusBriefs/AmicusBriefsApp'
import { MobileHeader } from '@/web-components/MobileMenu'
import { loadSwipers } from '@components/swiper-js/swiper'
import { BapFormApp } from '@web-components/BapFormApp/BapFormApp'
import { DesktopHeader } from '@web-components/DesktopMenu'
import { KyMobileDropDownToggle } from '@web-components/KyMobileDropDownToggle'
import { StaffApp } from '@web-components/StaffApp/StaffApp'
import { customElement, noShadowDOM } from 'solid-element'
import type { ComponentProps } from 'solid-js'
import styles from './tailwind-web-components.css?inline'
import { CaseStudiesApp } from './web-components/CaseStudiesApp/CaseStudiesApp'

const loadWebComponents = () => {
  customElement<ComponentProps<typeof DesktopHeader>>(
    'ky-desktop-header',
    {
      logo: '',
    },
    (props) => {
      noShadowDOM()
      return DesktopHeader(props)
    }
  )

  customElement<ComponentProps<typeof MobileHeader>>(
    'ky-mobile-header',
    {
      logo: '',
    },
    (props) => {
      noShadowDOM()
      return MobileHeader(props)
    }
  )

  customElement<ComponentProps<typeof KyMobileDropDownToggle>>(
    'ky-mobile-drop-down-toggle',
    {},
    (props) => {
      noShadowDOM()

      return <KyMobileDropDownToggle {...props} />
    }
  )

  customElement<ComponentProps<typeof CaseStudiesApp>>(
    'case-studies-app',
    {
      apiBaseUrl: window.location.origin,
    },
    (props) => {
      noShadowDOM()
      return CaseStudiesApp(props)
    }
  )

  customElement<ComponentProps<typeof StaffApp>>('onemagnify-staff-app', {}, (props) => {
    return StaffApp(props)
  })

  customElement<ComponentProps<typeof BapFormApp>>(
    'bap-form-app',
    {
      companyTaxonomy: 'bap_category',
      companyType: 'bap_company',
    },
    (props) => {
      noShadowDOM()
      return BapFormApp(props)
    }
  )

  customElement<ComponentProps<typeof BapFormApp>>(
    'yellowpages-form-app',
    {
      companyTaxonomy: 'yp_category',
      companyType: 'yp_company',
    },
    (props) => {
      noShadowDOM()
      return BapFormApp(props)
    }
  )

  customElement<ComponentProps<typeof AmicusBriefsApp>>('amicus-app', { class: '' }, (props) => {
    noShadowDOM()
    return AmicusBriefsApp(props)
  })
}

loadWebComponents()

function injectStyles(host: HTMLElement) {
  if (host.shadowRoot) {
    // If shadowRoot already exists, inject styles immediately
    const style = document.createElement('style')
    style.textContent = styles
    host.shadowRoot.appendChild(style)
  } else {
    // If shadowRoot doesn't exist yet, use MutationObserver to wait for it
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && host.shadowRoot) {
          const style = document.createElement('style')
          style.textContent = styles
          host.shadowRoot.appendChild(style)
          observer.disconnect() // Stop observing once styles are injected
        }
      })
    })

    // Start observing the host element for childList changes
    observer.observe(host, { childList: true })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const element = document.querySelector(['case-studies-app', 'onemagnify-staff-app'].join(','))

  if (element) {
    injectStyles(element as HTMLElement)
  }
})

loadSwipers()
